import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanelHeader,{staticStyle:{"padding":"0px 24px 0px 0px"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c(VIcon,{attrs:{"small":"","left":""}},[_vm._v("fa-chevron-down")])]},proxy:true}])},[_c('div',{staticClass:"cotacao"},[_c('img',{attrs:{"src":'data:image/png;base64, ' + _vm.img}}),_c('h3',[_vm._v("\n      "+_vm._s(_vm.nome)+"\n      "),_c('br'),_c('span',[_vm._v(_vm._s(_vm.preco))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }